import React from "react";
import { useNavigate } from "react-router-dom";

function ThankYouPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex justify-center items-center bg-gray-100">
      <div className="w-full max-w-md px-8 py-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Thank You!
        </h1>
        <p className="text-gray-700 text-lg md:text-xl mb-8">
          Thank you for submitting your form. We appreciate your interest and
          will get back to you as soon as possible.
        </p>
        <button
          onClick={() => {
            navigate("/");
          }}
          className="type-button bg-black hover:bg-[#FFDB16] text-white hover:text-black py-2 px-4 rounded-full focus:outline-none focus:shadow-outline"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default ThankYouPage;
